import {
    SimplePageContentWrapper,
    SimplePageLayout,
    PlatformLoader
} from '@flexinet/ui-components';

import {Alert} from '@mantine/core';
import {AiOutlineInfoCircle} from 'react-icons/ai';

import {ProfilePageHeader} from '../components/ProfilePageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {useUserAccount} from '../../../../hooks/useUserAccount';
import {Profile} from '../profile/Profile';

export const IndexPage = () => {
    const {userAccount} = useUserAccount();
    const loading = false;

    if (loading) {
        return <PlatformLoader message="Loading your account information..."/>;
    }

    if (!userAccount) {
        return (
            <SimplePageLayout
                pageHeader={<ProfilePageHeader/>}
                pageNavigation={<IndexPageNavigation/>}
            >
                <SimplePageContentWrapper>
                    <Alert
                        variant="light"
                        color="yellow"
                        title="Account information unavailable"
                        icon={<AiOutlineInfoCircle/>}
                    >
                        We could not load your account information. Try refreshing
                        the page, or contact support if the problem persists.
                    </Alert>
                </SimplePageContentWrapper>
            </SimplePageLayout>
        );
    }

    return (
        <SimplePageLayout
            pageHeader={<ProfilePageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <Profile record={userAccount} showDangerZone/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
